import { Link } from 'react-router-dom';
import { getRankedComics } from '@/mocks/comics';
import RankingRow from '@/components/feature/RankingRow';

export default function MustRead() {
  const list = getRankedComics('must-read').slice(0, 5);

  return (
    <section className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between">
              <div>
                <span className="flex items-center gap-2 text-sm font-semibold text-primary-600">
                  <i className="ri-medal-fill text-base" />
                  新手必看
                </span>
                <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">韩漫必看榜 Top5</h2>
              </div>
              <Link to="/ranking/must-read" className="flex shrink-0 items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800">
                完整必看榜 <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>
            <div className="mt-6 space-y-2 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4">
              {list.map((comic, i) => (
                <RankingRow key={comic.id} comic={comic} rank={i + 1} />
              ))}
            </div>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-lg border border-accent-200 bg-accent-100/70 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-compass-3-line text-xl" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">韩漫入坑指南</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                刚接触韩国漫画不知从何看起？必看榜收录了各类型的入门代表作，从热血奇幻到治愈日常，帮你快速建立韩漫审美，从此不再书荒。
              </p>
              <Link to="/faq" className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-800 hover:text-accent-900">
                阅读入坑常见问题 <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                <i className="ri-refresh-line text-xl" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">榜单实时更新</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                人气榜、评分榜与必看榜根据读者追更热度与口碑动态排序，跟着榜单追，轻松锁定当下最值得看的韩国漫画。
              </p>
              <Link to="/ranking/popularity" className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800">
                去人气榜看看 <i className="ri-arrow-right-line text-sm" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}